// Root components
import App from "containers/App/App"
import SEOWrapper from "containers/SEOWrapper"

// Lazy-loaded Components
import PageAbout from "containers/PageAbout/PageaboutLoader"
import PageAmazonAlexa from "containers/PageAmazonAlexa/PageamazonalexaLoader"
import PageAndroid from "containers/PageAndroid/PageandroidLoader"
import PageAppleTV from "containers/PageAppleTV/PageappletvLoader"
import PageCategory from "containers/PageCategory/PagecategoryLoader"
import PageChannel from "containers/PageChannel/PagechannelLoader"
import PageChannelReplay from "containers/PageChannelReplay/PagechannelreplayLoader"
import PageChromecast from "containers/PageChromecast/PagechromcastLoader"
import PageCookiesSettings from "containers/PageCookiesSettings/PagecookiessettingsLoader"
import PageDeeplink from "containers/PageDeeplink/PagedeeplinkLoader"
import PageDesktop from "containers/PageDesktop/PagedesktopLoader"
import PageDevices from "containers/PageDevices/PagedevicesLoader"
import PageDirect from "containers/PageDirect/PagedirectLoader"
import PageFreeChannels from "containers/PageFreeChannels/PagefreechannelsLoader"
import PageGenre from "containers/PageGenre/PagegenreLoader"
import PageGoogleAssistant from "containers/PageGoogleAssistant/PagegoogleassistantLoader"
import PageHardware from "containers/PageHardware/PagehardwareLoader"
import PageHome from "containers/PageHome/PagehomeLoader"
import PageHuawei from "containers/PageHuawei/PagehuaweiLoader"
import PageIphone from "containers/PageIphone/PageiphoneLoader"
import PageLG from "containers/PageLG/PagelgLoader"
import PageLink from "containers/PageLink/PagelinkLoader"

import PageNotifications from "containers/PageNotifications/PagenotificationsLoader"
import PageOnMyTv from "containers/PageOnMyTv/PageonmytvLoader"

import PagePanasonic from "containers/PagePanasonic/PagepanasonicLoader"
import PageParentalControl from "containers/PageParentalControl/PageparentalcontrolLoader"
import PagePayment from "containers/PagePayment/PagepaymentLoader"
import PageProductIframe from "containers/PageProductIframe/PageproductiframeLoader"
import PageProfile from "containers/PageProfile/PageprofileLoader"
import PageProgram from "containers/PageProgram/PageprogramLoader"
import PagePromoCode from "containers/PagePromoCode/PagepromocodeLoader"
import PageTVReplays from "containers/PageTVReplays/PagetvreplaysLoader"
import PageSamsung from "containers/PageSamsung/PagesamsungLoader"
import PageSEOHome from "containers/PageSEOHome/PageseohomeLoader"
import PageSEOSection from "containers/PageSEOSection/PageseosectionLoader"

import PageStorage from "containers/PageStorage/PagestorageLoader"
import PageStreaming from "containers/PageStreaming/PagestreamingLoader"
import PageSubscribe from "containers/PageSubscribe/PagesubscribeLoader"
import PageLandingStrapi from "containers/PageLandingStrapi/PagelandingstrapiLoader"
import PageUnsubscribeEmail from "containers/PageUnsubscribeEmail/PageunsubscribeemailLoader"
import PageUnsubscribeStep1 from "containers/PageUnsubscribeStep1/Pageunsubscribestep1Loader"
import PageUnsubscribeStep2 from "containers/PageUnsubscribeStep2/Pageunsubscribestep2Loader"
import PageXbox from "containers/PageXbox/PagexboxLoader"
import PageXiaomiStick from "containers/PageXiaomiStick/PagexiaomistickLoader"
import PageHisense from "containers/PageHisense/PagehisenseLoader"

// Components
import AuthenticationWrapper from "containers/AuthenticationWrapper/AuthenticationWrapper"
import PageChangePassword from "containers/PageChangePassword"
import PageChangeEmail from "containers/PageChangeEmail"
import PageDownloading from "containers/PageDownloading"
import PageError from "containers/PageErrors/PageError"
import PageLegal from "containers/PageLegal"
import PageLegalText from "containers/PageLegalText"
import PageNotFound from "containers/PageErrors/PageNotFound"
import PageOAuth from "containers/PageOAuth"
import PageProducts from "containers/PageProducts"
import PageResetPassword from "containers/PageResetPassword"
import PageResetEmail from "containers/PageResetEmail"
import PublicWrapper from "containers/PublicWrapper"
import Nav from "components/Nav/Nav"

import routes from "consts/routes"

/**
    Route configuration
    To render a <Route /> component:
    - path {string} - if not set, the route will match all path
    - paths {array} - array of path
    - component {component} - component rendered for the route
    - routeProps {object} - props that will be
      forwarded as is to the <Route /> component (NOT to the
      component rendered for the route)
    - modulePath {string} - Path to the module to require it for
      server-side rendering
    - loadable {object} (mandatory if the route is lazy-loaded)
    To render a <Redirect /> component:
    - from {string}
    - to {string}
*/

const iframeProductsUrl = [
  `${routes.products}/channel/:channelId`,
  `${routes.products}/channel/:channelId/program/:programId`,
  `${routes.products}/bookmarks`,
  `${routes.products}/url/:apiPath?`,
]

export const rootRoutes = [
  {
    paths: [
      routes.program,
      routes.channel,
      routes.channelReplay,
      "/:locale([a-z]{2}_[a-z]{2})",
      routes.deeplink,
      routes.category,
      routes.genre,
      routes.tvReplay,
      routes.tvFreeChannels,
    ],
    component: SEOWrapper,
  },

  {
    path: routes.oauth,
    component: PageOAuth,
  },

  {
    path: routes.linktv,
    ...PageLink,
  },

  {
    component: App,
  },
]

export const appRoutes = [
  {
    paths: ["/account", ...iframeProductsUrl, "/gift/buy", "/promo"],
    component: AuthenticationWrapper,
  },

  {
    component: PublicWrapper,
  },
]

export const SEORoutes = [
  {
    path: routes.seoHomeSection,
    ...PageSEOSection,
  },

  {
    path: routes.seoHome,
    ...PageSEOHome,
  },

  {
    paths: [routes.categoryPage, routes.category],
    ...PageCategory,
    routeProps: {
      exact: true,
    },
  },

  {
    paths: [routes.genre, routes.genrePage],
    ...PageGenre,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.program,
    ...PageProgram,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.channel,
    ...PageChannel,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.tvReplay,
    ...PageTVReplays,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.tvFreeChannels,
    ...PageFreeChannels,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.channelReplay,
    ...PageChannelReplay,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.deeplink,
    ...PageDeeplink,
    routeProps: {
      exact: true,
    },
  },

  // Not Found
  {
    component: PageNotFound,
  },
]

export const publicRoutes = [
  // Home
  {
    path: "/",
    ...PageHome,
    routeProps: {
      exact: true,
    },
  },
  // Home
  {
    path: "/index.html",
    ...PageHome,
    routeProps: {
      exact: true,
    },
  },

  // About
  {
    path: routes.about,
    ...PageAbout,
    routeProps: {
      exact: true,
    },
  },

  // Android
  {
    path: routes.deviceAndroid,
    ...PageAndroid,
    routeProps: {
      exact: true,
    },
  },

  // Huawei
  {
    path: routes.deviceHuawei,
    ...PageHuawei,
    routeProps: {
      exact: true,
    },
  },

  // Page Hisense
  {
    path: routes.deviceHisense,
    ...PageHisense,
    routeProps: {
      exact: true,
    },
  },

  // Apple Tv
  {
    path: routes.deviceAppleTv,
    ...PageAppleTV,
    routeProps: {
      exact: true,
    },
  },

  // Chromecast
  {
    path: routes.deviceChromecast,
    ...PageChromecast,
    routeProps: {
      exact: true,
    },
  },

  // Change Password
  {
    path: routes.changePassword,
    component: PageChangePassword,
    routeProps: {
      exact: true,
    },
  },

  // Change Email
  {
    path: routes.changeEmail,
    component: PageChangeEmail,
    routeProps: {
      exact: true,
    },
  },

  // Desktop
  {
    path: routes.deviceDesktop,
    ...PageDesktop,
    routeProps: {
      exact: true,
    },
  },

  // Download
  {
    path: routes.download,
    component: PageDownloading,
    routeProps: {
      exact: true,
    },
  },

  // Error
  {
    path: routes.error,
    component: PageError,
    routeProps: {
      exact: true,
    },
  },

  // Hardware
  {
    path: routes.hardware,
    ...PageHardware,
    routeProps: {
      exact: true,
    },
  },

  // Iphone
  {
    path: routes.deviceIphone,
    ...PageIphone,
    routeProps: {
      exact: true,
    },
  },

  // Legal
  {
    path: routes.legal,
    component: PageLegal,
    routeProps: {
      exact: true,
    },
  },

  {
    paths: [routes.gtu, routes.privacy, routes.cookies, routes.mentions],
    component: PageLegalText,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.cookiesSettings,
    ...PageCookiesSettings,
    routeProps: {
      exact: true,
    },
  },

  // LG
  {
    path: routes.deviceLg,
    ...PageLG,
    routeProps: {
      exact: true,
    },
  },

  // Products
  {
    paths: [routes.products],
    component: PageProducts,
    routeProps: {
      exact: true,
    },
  },

  // Public offer
  {
    paths: [routes.publicOffer],
    ...PageProductIframe,
    routeProps: {
      exact: true,
    },
  },

  // Reset Password
  {
    path: routes.resetPassword,
    component: PageResetPassword,
    routeProps: {
      exact: true,
    },
  },

  // Reset Email
  {
    path: routes.resetEmail,
    component: PageResetEmail,
    routeProps: {
      exact: true,
    },
  },

  // On My TV
  {
    path: routes.tvPublic,
    ...PageOnMyTv,
    routeProps: {
      exact: true,
    },
  },

  // Landing Strapi
  {
    path: routes.landingStrapi,
    ...PageLandingStrapi,
    routeProps: {
      exact: true,
    },
  },

  // Samsung
  {
    path: routes.deviceSamsung,
    ...PageSamsung,
    routeProps: {
      exact: true,
    },
  },

  // Panasonic
  {
    path: routes.devicePanasonic,
    ...PagePanasonic,
    routeProps: {
      exact: true,
    },
  },

  // Google Assistant
  {
    path: routes.deviceGoogleAssistant,
    ...PageGoogleAssistant,
    routeProps: {
      exact: true,
    },
  },

  // Xbox
  {
    path: routes.deviceXbox,
    ...PageXbox,
    routeProps: {
      exact: true,
    },
  },

  // Xiaomi Stick
  {
    path: routes.deviceXiaomi,
    ...PageXiaomiStick,
    routeProps: {
      exact: true,
    },
  },

  // Amazon Alexa
  {
    path: routes.deviceAmazonAlexa,
    ...PageAmazonAlexa,
    routeProps: {
      exact: true,
    },
  },

  // Subscribe
  {
    paths: [routes.subscribe],
    ...PageSubscribe,
    routeProps: {
      exact: true,
    },
  },

  // TV Direct
  {
    path: routes.tvDirect,
    ...PageDirect,
    routeProps: {
      exact: true,
    },
  },

  // TV Streaming
  {
    path: routes.tvStreaming,
    ...PageStreaming,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.unsubscribeEmail,
    ...PageUnsubscribeEmail,
    routeProps: {
      exact: true,
    },
  },

  // Not Found
  {
    component: PageNotFound,
  },
]

export const authenticatedRoutes = [
  {
    from: routes.account,
    to: routes.profile,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.profile,
    ...PageProfile,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.storage,
    ...PageStorage,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.parentalControl,
    ...PageParentalControl,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.payment,
    ...PagePayment,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.devices,
    ...PageDevices,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.tv,
    ...PageOnMyTv,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.offers,
    component: PageProducts,
    routeProps: {
      exact: true,
    },
  },

  {
    paths: [routes.offer, ...iframeProductsUrl],
    ...PageProductIframe,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.notifications,
    ...PageNotifications,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.promoCode,
    ...PagePromoCode,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.unsubscribeStep2,
    ...PageUnsubscribeStep2,
    routeProps: {
      exact: true,
    },
  },

  {
    path: routes.unsubscribeStep1,
    ...PageUnsubscribeStep1,
    routeProps: {
      exact: true,
    },
  },

  // Not Found
  {
    component: PageNotFound,
  },
]

export const navRoutes = [
  {
    paths: [routes.profile, routes.storage, routes.parentalControl, routes.payment, routes.devices, routes.tv, routes.offers, routes.notifications],
    component: Nav,
    routeProps: {
      exact: true,
    },
  },

  // Not Found
  {
    component: null,
  },
]
